import type { Messages } from '../messages.js'

/**
 * Macedonian. `потег` for flips, the word a Macedonian board game uses for a move.
 *
 * Macedonian, like Bulgarian, has no cases and a postposed article, so the interface reads with
 * far fewer endings than the other Slavic languages here.
 */
export const mk: Messages = {
  tag: 'mk',

  readingDictionary: 'Го читам речникот…',
  noWordList: 'Нема список со зборови за „{language}“. Направете го:  pnpm dictionary build',
  emptyWordList: 'Списокот со зборови за „{language}“ е празен.',

  flips: 'потези',
  score: 'резултат',
  words: 'зборови',
  round: 'рунда',
  ticksLeftLabel: 'Преостанато време во оваа рунда',
  typeAWord: 'напишете збор',
  tapPrompt: 'допрете букви за да ги изберете или вратите, потоа {action}',

  boardOfTiles: 'Табла со {n} плочки',
  faceDown: 'свртено надолу',
  wildCard: 'џокер',
  wildKey: 'која било буква',
  letterReplaced: '{from} стана {to}',
  letterSwap: 'ЗАМЕНА НА БУКВИ!',
  spentTile: 'искористена плочка',
  hiddenWhilePaused: 'скриено додека е паузирано',
  letterInWord: '{letter}, {position}-та буква од зборот',

  completeWord: 'Заврши го зборот',

  completeShort: 'Заврши',
  reset: 'Исчисти',
  pause: 'Пауза',
  resume: 'Продолжи',
  newGame: 'Нова игра',
  paused: 'Паузирано',
  outOfFlips: 'Снема потези',
  finalResult: '{score} за {words} во {rounds}',
  playAgain: 'Играј повторно',
  share: 'Сподели',
  shareCopied: 'Копирано.',
  shareSelect: 'Копирајте го ова:',

  lettersSelect: 'буквите избираат',
  keysWild: 'се зема кога ќе напишете буква што ниту една плочка не ја покажува',
  clearsEvery: 'ги чисти сите избрани {letter}',
  undoLastLetter: 'врати ја последната буква',
  noWordsYet: 'Сè уште нема зборови.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'веќе е најден',
  reasonTooShort: 'премногу краток',
  reasonNotAWord: 'тоа не е збор',
  reasonAllFound: 'веќе ги имате сите',
  noSuchLetterUp: 'нема откриено {letter}',
  nothingUp: 'ништо не е откриено',
  letterHidden: 'една буква се сокри',
  shuffled: 'промешано',
  shuffledAndBilled: 'промешано, одбиени {flips} неискористени',
  tooFewLetters: 'Останаа премалку букви',

  gameLanguage: 'јазик',
  interfaceLanguage: 'изглед',
  dictionarySize: '{common} секојдневни од {full} зборови',
  filterLanguages: 'Барај јазик',
  noMatches: 'Нема совпаѓања',

  nerdMode: 'режим за познавачи',
  rules: 'Правила',
  difficulty: 'тежина',
  difficultyNames: { easy: 'лесна', medium: 'средна', hard: 'тешка', insane: 'луда' },
  pausedNoBoard: 'Оваа игра нема да влезе во ранг-листата.',
  about: 'За играта',
  themeLabel: 'тема',
  themeNames: { traditional: 'традиционална', light: 'светла', contrast: 'висок контраст' },
  tiles: 'плочки (N)',
  secondsPerTick: 'секунди / такт',
  holdTicks: 'тактови задржување',
  minWord: 'најкраток збор',
  startingFlips: 'почетни потези',
  wildChance: 'шанса за џокер',
  replaceChance: 'шанса за замена на буква',
  hideChance: 'шанса за криење на буква',
  wordCompleteMode: 'кога зборот е завршен',
  wordCompleteNames: { shuffle: 'промешај', spend: 'потроши', keep: 'задржи' },
  flipEconomy: 'враќање потези',
  flipEconomyNames: {
    none: 'нема',
    perLetter: 'по буква',
    fibonacci: 'фибоначи',
    overMinimum: 'над минимумот',
  },
  repeatedLetterKey: 'копче за повторена буква',
  keySchemeNames: { cycle: 'круг', advance: 'напред' },
  keySchemeHelp: {
    cycle:
      'А го зема следното неискористено А, а кога сите се во зборот, ги чисти. ' +
      'Shift+А исто така ги чисти.',
    advance: 'А го зема следното неискористено А. Shift+А ги чисти сите А од зборот.',
  },

  whatThatMeans: 'Што значи тоа',
  factRound: 'рунда',
  factWholeBoardUp: 'целата табла откриена',
  factRoundCosts: 'една рунда чини',
  factFlipsBuy: 'почетните потези купуваат',
  factThisBoard: 'оваа табла',
  factBoardHadToAdmit: 'таблата мораше да прими',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, најдолг {longest}',
  wordsIncludingOneOf: '{words}, од кои еден од {ceiling}',
  scorelessRounds: '{rounds} без поени',

  whatAWordPays: 'Што носи еден збор',
  columnLetters: 'букви',
  columnCost: 'цена',
  columnPoints: 'поени',
  columnFlips: 'потези',
  columnNet: 'разлика',

  canonicalRules: 'Вообичаени правила за {difficulty}.',
  customRules:
    'Изменето од поставеното. Резултати по сопствени правила не влегуваат во ранг-листа.',
  applyAndStart: 'Примени и почни нова игра',
  changesNextGame: 'Промените важат од следната игра.',
  presets: 'Поставки:',

  start: 'Почни',
  restart: 'Од почеток',
  quit: 'Излези',
  quitTitle: 'Да излезете од оваа игра?',
  restartTitle: 'Да ја почнете оваа игра од почеток?',
  restartConfirm: 'Од почеток',
  quitConfirm: 'Излези',
  keepPlaying: 'Продолжи да играш',
  personalBest: 'Вашите најдобри игри',
  newPersonalBest: 'Нов личен рекорд.',
  columnRank: '#',
  notRanked: 'Сопствени правила, па оваа игра не влегува во ранг-листа.',
  notRankedPaused: 'Часовникот запре, па оваа игра не влегува во ранг-листа.',
  rankOfTotal: '{rank} од {total}',

  howToPlay: 'Како се игра',

  backToGame: 'Назад кон играта',
  welcomeTitle: 'Добредојдовте во Blinkered',
  tutorialSkip: 'Прескокни',
  tutorialNext: 'Натаму',
  tutorialBack: 'Назад',
  tutorialStart: 'Почни да играш',
  tutorialHideAgain: 'Не покажувај го ова повторно',
  tutorialProgress: '{n} од {total}',
  tutorialSkipTitle: 'Да го прескокнете запознавањето?',
  tutGoalTitle: 'Blinkered е трка',
  tutGoalBody:
    'Играта ја почнувате со определен број потези, а секоја откриена плочка чини еден потег. Кога потезите ќе снемаат, играта е готова. Зборовите носат потези, и колку е подолг зборот, толку повеќе потези добивате.',
  tutSpentBody:
    'Буквите што ги користите во збор се вртат наопаку до следната рунда. Само замената на буква менува кои букви се на таблата.',
  tutChangeTitle: 'Буквите може да се менуваат',
  tutSameLetters:
    'Видовте збор што не стигнавте да го одиграте? Истите букви се враќаат во следната рунда, измешани на нови места.',
  tutPickLetters: 'Допирајте ги буквите што ги сакате, по ред, за да составите збор.',
  tutMoreTurn:
    'Плочките продолжуваат да се вртат додека размислувате, па подобра буква сè уште може да дојде.',
  tutTapBack:
    'Зедовте буква што не ја сакавте? Допрете ја пак и ќе се врати. Која било, не само последната.',
  tutComplete: 'Кога зборот е готов, притиснете Заврши.',
  htBoardTitle: 'Таблата',
  htBoardBody:
    'Плочките се откриваат една по една, во случаен ред. Од откриените се составуваат зборови.',
  htWordsTitle: 'Зборовите',
  htWordsBody: 'Составете збор од откриените плочки со пишување или кликање на буквите по ред.',
  htFlipsTitle: 'Потезите',
  htFlipsBody:
    'Секоја откриена плочка чини потег. Завршен збор враќа потези, а подолгите зборови враќаат повеќе. Кога потезите ќе снемаат, играта е готова.',
  htRoundTitle: 'Рундата',
  htRoundBody:
    'Кога ќе се открие последната плочка од рундата, целата табла застанува за миг. Потоа плочките се вртат и се мешаат, и почнува нова рунда.',
  htLanguagesTitle: 'Јазиците',
  htLanguagesBody:
    'Ги има {n}. Секоја табла може да се реши со зборови што луѓето навистина ги користат. Редок збор исто така носи поени, ако речникот го знае.',
  htKeysTitle: 'Тастатурата',
  htWildTitle: 'Џокерите',
  htWildBody:
    'Понекогаш наместо буква се појавува џокер. Џокерот важи за која било буква што прави исправен збор. Веќе најден збор не се брои.',
  htHideTitle: 'Букви што се кријат',
  htHideBody:
    'На потешките нивоа откриена буква може сама да се сврти и да се врати подоцна во кругот. Тајмерот за тоа добива дополнителен такт, во црвено. Веќе избраните букви не се вртат.',
  tutHideBody:
    'На потешките нивоа откриена буква може сама да се сврти и да се врати подоцна во кругот. Веќе избраните букви не се вртат.',
  htSwapTitle: 'Букви што се менуваат',
  htSwapBody:
    'Понекогаш меѓу рундите една буква се заменува со друга. Ќе видите која си отиде и која дојде.',
  htLevelsTitle: 'Нивоата',
  htLevelEasy:
    'Истите дванаесет букви цела игра, па можете да ги научите и да носите список зборови во главата. Плочките се откриваат бавно, а целата табла останува видлива доволно долго за да го довршите изборот.',
  htLevelMedium:
    'Одвреме-навреме една буква се менува, па потешко е да се памтат зборови оставени за подоцна. Помалку време за гледање и помалку за размислување.',
  htLevelHard:
    'Зборовите од три букви престануваат да се бројат, а буква се менува околу секоја втора рунда. Таблата едвај се покажува, а веќе се меша.',
  htLevelInsane: 'Сè одеднаш и со полна брзина. Таблата се меша речиси веднаш по последниот потег.',
  htTouchTitle: 'Екранот на допир',
  htTouchBody:
    'Допрете откриена плочка за да ја земете нејзината буква. Допрете земена буква за да ја вратите. Заврши и Исчисти се под таблата.',

  accountTitle: 'Твојата сметка',
  menuProfile: 'Мојот профил',
  menuGames: 'Моите игри',
  menuPublicPage: 'Мојата јавна страница',
  menuSignedInAs: 'Најавен како',
  signIn: 'Најава',
  signOut: 'Одјава',
  signInTitle: 'Најави се или отвори сметка',
  signInLead: 'Сметката ги чува твоите игри, на секој уред.',
  signInKeepGame: 'Најави се за да ја зачуваш оваа игра, и секоја следна.',
  continueWithApple: 'Продолжи со Apple',
  continueWithGoogle: 'Продолжи со Google',
  signInOr: 'или',
  emailLabel: 'Е-пошта',
  codeLabel: 'Код',
  emailMeACode: 'Испратете ми код',
  working: 'Момент…',
  sendNewCode: 'Испрати нов код',
  codeSent: 'Провери ја поштата. Кодот важи 10 минути.',
  notNow: 'Не сега',
  badEmail: 'Ова не личи на адреса за е-пошта.',
  badCode: 'Тој код не работеше. Кодовите истекуваат по 10 минути и важат еднаш.',
  serverBusy: 'Серверот е недостапен. Обиди се за момент.',
  serverDown: 'Серверот е недостапен.',
  offline: 'Офлајн',
  leaderboardTitle: 'Ранг-листа',
  leaderboardEmpty: 'Сè уште нема игри на оваа листа. Биди првиот.',
  leaderboardWouldBe: 'Каде би стоела оваа игра',
  leaderboardThisGame: 'Оваа игра',
  leaderboardRanksHere: 'Каде стои оваа игра',
  leaderboardOutside: 'Надвор од првите пет.',
  tutAccountTitle: 'Зачувај ги своите резултати',
  tutAccountBody:
    'Сметката ги чува твоите игри, ги става резултатите на ранг-листата и го одржува твојот профил.',
  ssoCancelled: 'Најавата е откажана.',
  ssoExpired: 'Предолго траеше. Најави се повторно.',
  ssoNoUsername: 'Сметката не можеше да се доврши. Обиди се за момент.',
  ssoFailed: 'Не успеа. Обиди се повторно или користи е-пошта.',
  tabProfile: 'Профил',
  countryAny: 'Претпочитам да не кажам',
  findCountry: 'Пребарај држави',
  usernameLabel: 'Корисничко име',
  bioLabel: 'За мене',
  countryLabel: 'Држава',
  bioHint: 'Без линкови. {left}/{max}',
  save: 'Зачувај',
  saving: 'Зачувувам…',
  saved: 'Зачувано.',
  nameTaken: 'Некој веќе го има тоа име.',
  nameTooShort: 'Малку подолго, те молам.',
  nameTooLong: 'Предолго е.',
  nameBadCharacters: 'Само букви, бројки, цртички и долни црти.',
  nameBadEdges: 'Мора да почне и заврши со буква или бројка.',
  nameMixedScripts: 'Избери едно писмо и остани во него.',
  nameReserved: 'Ова личи на име што го делиме ние. Избери друго.',
  nameUnusable: 'Тоа име не може да се користи.',
  bioTooLong: 'Описот има најмногу {max} знаци.',
  bioHasLink: 'Линкови во описот не се дозволени.',
  bioHasControl: 'Содржи знаци што описот не може да ги има.',
  bioUnusable: 'Тој опис не може да се користи.',
  gamesHeading: 'Игри',
  gamesEmpty: 'Овде сè уште нема ништо. Игрите што ќе ги играш најавен ќе се појават тука.',
  gamesEmptyShort: 'Овде сè уште нема ништо.',
  gamesLoading: 'Ги читам твоите игри…',
  theirGamesLoading: 'Ги читам нивните игри…',
  profileLoading: 'Го читам профилот…',
  playerNotFound: 'Тука нема никој со тоа име.',
  columnWhen: 'Кога',
  columnRounds: 'рунди',
  columnGame: 'Игра',
  gameLoading: 'Ја читам играта…',
  gameUnreadable: 'Оваа игра не можеше да се прочита.',
  gameNotRanked: 'Играна со изменети правила, па не се рангира.',
  detailNotKept: 'Зборовите и таблите на оваа игра повеќе не се чуваат.',
  openingBoard: 'Почетната табла',
  roundByRound: 'Рунда по рунда',
  roundNothing: 'ништо не е најдено',
  changeReplaced: '{letter} заменета на место {slot}',
  changeWildOn: '{letter} џокер на место {slot}',
  changeWildOff: '{letter} џокер тргнат од место {slot}',
  keepThisGame: 'Зачувај ја оваа игра',
  savedToYourGames: 'Зачувано во твоите игри.',

  reportThis: 'Пријави',
  reportHeading: 'Пријави го ова',
  reportTheName: 'Името',
  reportTheBio: 'Описот',
  reportTheScore: 'Резултатот',
  reportWhy: 'Што не е во ред со него? Изборно.',
  reportSend: 'Испрати ја пријавата',
  reportSent: 'Благодариме. Некој ќе го погледне.',
  reportSignIn: 'За ова мораш да си најавен.',
  reportGone: 'Тоа го нема повеќе.',
  reportCancel: 'Откажи',

  deleteAccount: 'Избриши го мојот профил',
  deleteAccountWhat:
    'Ова засекогаш го отстранува твојот профил и секоја зачувана игра. Не може да се врати.',
  deleteAccountAsk: 'Пратете ми код',
  deleteConfirm: 'Избриши засекогаш',
  deleteGone: 'Твојот профил го нема. Благодариме што играше.',
  deleteNoAddress:
    'На овој профил нема потврдена адреса, па бришењето не може да се провери. Контактирај не и ќе го направиме рачно.',

  rulesetFacts: 'Зборови од {letters} · нова плочка на секои {seconds}',
  plurals: {
    words: { one: '{n} збор', other: '{n} зборови' },
    rounds: { one: '{n} рунда', other: '{n} рунди' },
    flips: { one: '{n} потег', other: '{n} потези' },
    ticks: { one: '{n} такт', other: '{n} тактови' },
    points: { one: '{n} поен', other: '{n} поени' },
    minLetters: { one: 'најмалку {n} буква', other: 'најмалку {n} букви' },
    seconds: { one: '{n} секунда', other: '{n} секунди' },
  },
}
